import api from "@/axios";

export default {
  findAll() {
    return api().get("faq");
  },
  findOne(id) {
    return api().get(`admin/faq/${id}`);
  },
  create(data) {
    return api().post("admin/faq/add", data);
  },
  update(id, data) {
    return api().patch(`admin/faq/${id}`, data);
  },
  remove(id) {
    return api().delete(`faq/${id}`);
  },
};
